import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import NoSsr from '@material-ui/core/NoSsr';
import { reorder } from '../../../utils/list_helpers';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { StringConstantsMixin } from './mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const ListDisplayContainer = createReactClass({
  getInitialState() {
    return { lists: this.props.lists };
  },
  componentWillMount() {
    this.saveTimeoutId = undefined;
  },
  handleDeleteListClick(listId) {
    if (confirm('Are you sure you want to delete this list?')) {
      ServerCommunicationUtil.deleteApiEndpoint(
        `/api/alltrails/lists/${listId}`,
        {},
        data => {
          if (data && data.lists) {
            // remove deleted list immediately
            const removedId = data.lists[0].id;
            const newItems = this.state.lists.filter(list => {
              return list.id !== removedId;
            });
            this.setState({ lists: newItems });
          }
        },
        err => {
          console.log(err);
        },
        () => {}
      );
    }
  },
  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const lists = reorder(this.state.lists, result.source.index, result.destination.index);
    this.setState(
      {
        lists
      },
      this.saveListOrder
    );
  },
  saveListOrder() {
    if (this.listSaveOrderRequest) {
      this.listSaveOrderRequest.abort();
      this.listSaveOrderRequest = null;
    }

    const ids = this.state.lists
      .map(item => {
        return item.id;
      })
      .reverse();
    this.listSaveOrderRequest = $.ajax({
      type: 'POST',
      headers: { 'X-AT-KEY': ServerCommunicationUtil.apiKey },
      url: '/api/alltrails/lists/reorder',
      dataType: 'json',
      data: { ordered_list_ids: ids },
      success: (data, status, xhr) => {
        this.listSaveOrderRequest = null;
      },
      error(err) {
        console.log(err);
      }
    });
  },
  renderUserToggleButtons(list, idx, dragHandleProps = null) {
    if (!this.props.allowEditing) {
      return null;
    }

    return (
      <div className="control-container floatright">
        <div {...dragHandleProps} title="Move List" className="item-move clickable">
          <div />
        </div>
        <div
          title="Delete from List"
          className="item-delete clickable"
          onClick={this.handleDeleteListClick.bind(null, list.id)}
          data-test-id="deleteFromList"
        />
      </div>
    );
  },
  createListDiv(list, idx, dragHandleProps = null) {
    const userUrl = LanguageSupportUtil.wrapUrlSafe(`/members/${list.user.slug}`, this.props.context.languageRegionCode);
    const listUrl = LanguageSupportUtil.wrapUrlSafe(`/lists/${list.slug}`, this.props.context.languageRegionCode);
    const profilePhotoUrl = `/api/alltrails/lists/${list.id}/profile_photo?size=icon&key=${ServerCommunicationUtil.apiKey}`;
    return (
      <li className="trail clearfix" data-id={idx} key={idx}>
        <div className="title">
          <figure>
            <a href={listUrl}>
              <img src={profilePhotoUrl} className={`${StringConstantsMixin.constants.XLATE.NONE}`} alt={`${list.name}`} />
            </a>
          </figure>
          <h3>
            <a href={listUrl} className={`link ${StringConstantsMixin.constants.XLATE.NONE}`}>
              {list.name}
            </a>
          </h3>
          <h4>
            <a href={userUrl} className={`link ${StringConstantsMixin.constants.XLATE.NONE}`}>
              {`${list.user.firstName} ${list.user.lastName}`}
            </a>
          </h4>
        </div>
        {this.renderUserToggleButtons(list, idx, dragHandleProps)}
      </li>
    );
  },
  renderSortableList() {
    return (
      <NoSsr>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {provided => (
              <ol className="trails" {...provided.droppableProps} ref={provided.innerRef}>
                {this.state.lists.map((list, idx) => {
                  return (
                    <Draggable key={`${list.id}`} draggableId={`${list.id}`} index={idx}>
                      {provided => (
                        <li ref={provided.innerRef} {...provided.draggableProps}>
                          {this.createListDiv(list, idx, provided.dragHandleProps)}
                        </li>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </ol>
            )}
          </Droppable>
        </DragDropContext>
      </NoSsr>
    );
  },
  renderDefaultList() {
    const items = this.state.lists.map((item, idx) => {
      return this.createListDiv(item, idx);
    });

    return <ol className="trails make-sortable">{items}</ol>;
  },
  renderItems() {
    return this.props.allowEditing ? this.renderSortableList() : this.renderDefaultList();
  },
  render() {
    return this.renderItems();
  }
});

export { ListDisplayContainer };
